import React from 'react';

import { SelectInput} from '@sogei/react-web-components-catalog'
import { AppButton } from '../commons/button';
import { observer, inject } from "mobx-react";
import i18next from 'i18next';



@inject("rootStore")
@observer
class FornituraOnDemandCI extends React.Component {

  constructor(props) {
    super(props);
    this.item = this.props.item;
    this.element = this.props.element;
    this.ricevuteStore = props.rootStore.ricevuteStore;
    
  
  }

  componentDidMount() {
   
    
  }

 
   

  render() {

    const documentIcon = (border, icon, iconStyle, spanSrOnly, onClick,titolo) => {
        let customClass = 'btn btn-light border ' + border;
        let iconCenter = icon + ' ' + iconStyle;
        return <AppButton color="none" spanSrOnly={i18next.t(spanSrOnly)} customClass={customClass} iconCenter={iconCenter} type="button"  onClick={onClick} titleKey='' extraProps={{title:i18next.t(titolo)}}/>
      }

    
    const downloadDocumento = (item,element )=> {
      const downloadParam = {annoMese: this.props.annoMese};
        
        
  
      return documentIcon(
        /*element.warning?
          item[element.nomeKeyServizio] == element.warning ? 'border-warning' : 'border-danger'
          :
          'border-info',
          element.icon,
          element.warning?
          item[element.nomeKeyServizio] == element.warning ? 'icon-warning' : 'icon-danger'
          :
          'icon-info',
          element.spanSrOnly,
          () => {this.ricevuteStore.downloadFile(downloadParam)},
          ''
          */
          'border-primary',
          element.icon,
          'icon-primary',
          element.spanSrOnly,
          () => {this.ricevuteStore.fornituraOnDemandCI(downloadParam)},
          ''

          )
        }
     
  
  
  
    

    
  
  
  
  
  
    return (
        downloadDocumento(this.item,this.element)

    );
      
    }
    

    }
    
   
  






//export default SceltaTipoInvio;

export {FornituraOnDemandCI}; 